/* global $ */
/* eslint react/prop-types: 0 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './HideModalVideoLlamada.css';
import * as telemedicinaAction from '../../../../actions/telemedicinaActions';
import ModalConsultaSinFinalizar from '../../ModalConsultaSinFinalizar/ModalConsultaSinFinalizar';

class HideModalVideoLlamada extends React.Component {
  constructor(props) {
    super(props);
    this.hideModalVideoLlamada = this.hideModalVideoLlamada.bind(this);
  }

  hideModalVideoLlamada() {
    $('#modalConsultaSinFinalizar').modal('show');
    if (this.props.llamadaIniciada) {
      $('#estudiosIcon').popover('hide');
    } else {
      $('#modalVideoLlamada').fadeOut(200);
      $('#videoSwiss').each(function() {
        $(this)[0].pause();
      });
      // $('#modalFinalizado').modal({ backdrop: 'static', keyboard: false });
    }
  }

  render() {
    return (
      <div>
        <span
          id="modalVideoLlamadaHide"
          className={s.modalVideoLlamadaHide}
          onClick={() => {
            this.hideModalVideoLlamada();
          }}
          role="button"
          tabIndex="-1"
        >
          X
        </span>
        <ModalConsultaSinFinalizar disconnect={this.props.disconnect} />
      </div>
    );
  }
}

export default connect(null, telemedicinaAction)(
  withStyles(s)(HideModalVideoLlamada),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalVideoLlamada/HideModalVideoLlamada/HideModalVideoLlamada.js